export default (organisations, categories, categoryUuids) => {
  const childOrgs = categories.reduce((result, category) => [
    ...result,
    ...(categoryUuids.includes(category.uuid) ? category.organisations.map(({ uuid }) => uuid) : []),
    ...category.sub_categories.reduce((result, { uuid, organisations }) => {
      if (categoryUuids.includes(uuid)) {
        return [
          ...result,
          ...organisations.map(({ uuid }) => uuid)
        ]
      } else {
        return result
      }
    }, [])
  ], [])

  return organisations.reduce((result, organisation) => {
    const children =
      organisation
        .children
        .filter(({ value }) => childOrgs.includes(value))

    if (children.length) {
      result.push({ ...organisation, children })
    }

    return result
  }, [])
}
